import {
  createAuthHeyClient,
  logout,
  refreshToken as requestTokenRefresh,
} from "@platform/api/auth";

import type { SessionTokens } from "./session-storage";

const authClientFor = (apiBaseUrl: string) =>
  createAuthHeyClient(`${apiBaseUrl}brokerportal/v1`);

/** Exchanges a password session's refresh token for new tokens. */
export const refreshPasswordSession = async (
  apiBaseUrl: string,
  refreshToken: string,
): Promise<SessionTokens> => {
  const { data } = await requestTokenRefresh({
    client: authClientFor(apiBaseUrl),
    body: { refreshToken },
    throwOnError: true,
  });

  return {
    accessToken: data.access_token,
    idToken: data.id_token,
    refreshToken: data.refresh_token,
  };
};

/**
 * Revokes a password session's refresh token at Auth0, through the backend. Sent
 * without the access token, which may have expired while the refresh token is still
 * valid; the gateway would reject the request before it could revoke anything.
 */
export const revokePasswordSession = async (
  apiBaseUrl: string,
  refreshToken: string,
): Promise<void> => {
  await logout({
    client: authClientFor(apiBaseUrl),
    body: { refreshToken },
    throwOnError: true,
  });
};
